// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vert-voucher-picture {
  text-align: center;
  height: 188px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.vert-voucher-picture img {
  max-height: 128px;
}
.vert-voucher-body {
  border-top: solid 1px var(--color-border);
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/components/CartVoucher/index.less"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACF;AAAE;EACE,iBAAA;AAEJ;AAEA;EACE,yCAAA;AAAF","sourcesContent":[".vert-voucher-picture {\n  text-align: center;\n  height: 188px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  & img {\n    max-height: 128px;\n  }\n}\n\n.vert-voucher-body {\n  border-top: solid 1px var(--color-border);\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
